require('./investment.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
// @ commons
const { EmptyState } = require('commonsComponents/emptyState');
const { LoadingSection } = require('commonsComponents/loadingSection');
const { OKLink } = require('commonsComponents/OKLink');
const { StarsRating } = require('commonsComponents/starsRating');
// @ helpers
const { formatText, FormattedText } = require('core/i18n').i18n;

class Investment extends React.Component {
    componentWillMount() {
        this.props.getMorningStarInvestmentData(this.props.fundId);
    }

    // This is sort of a fallback function, because currently we don't have any users that load real information
    // from Morningstar. So, if any of the require fields for this component is not present, that means
    // the information we received from the service is not valid to show and we show an Empty State.
    allDataWasLoaded() {
        const { immMorningStarInvestmentData } = this.props;
        let allDataWasLoaded = true;

        if (allDataWasLoaded && !immMorningStarInvestmentData.get('name')) {
            allDataWasLoaded = false;
        }
        if (allDataWasLoaded && !immMorningStarInvestmentData.get('returnM0')) {
            allDataWasLoaded = false;
        }
        if (allDataWasLoaded && !immMorningStarInvestmentData.get('returnM12')) {
            allDataWasLoaded = false;
        }
        if (allDataWasLoaded && !immMorningStarInvestmentData.get('returnM36')) {
            allDataWasLoaded = false;
        }
        if (allDataWasLoaded && !immMorningStarInvestmentData.get('returnM60')) {
            allDataWasLoaded = false;
        }
        /* PENDING: For some reason all other values are available and this one isn't.
        We'll see what Morningstar people have to say about it in order to remove this
        block, update it or what.
        if (allDataWasLoaded && !immMorningStarInvestmentData.get('categoryName')){
            allDataWasLoaded = false;
        }*/
        if (allDataWasLoaded && !immMorningStarInvestmentData.get('rating')) {
            allDataWasLoaded = false;
        }
        return allDataWasLoaded;
    }

    render() {
        const { immMovements, immImposition, immMorningStarInvestmentData } = this.props;
        let content;

        if (
            immMovements.get('isFetching') ||
            immMorningStarInvestmentData.get('isFetching') ||
            immImposition.get('isFetching')
        ) {
            content = <LoadingSection />;
        } else if (!this.allDataWasLoaded()) {
            // This was not requested by the user story, but it is added because of the lack of users with
            // information that works normally. An empty state is loaded if the Fund info is not found in Morningstar.
            content = (
                <EmptyState primaryText={formatText('investment-notFound')} withMargin={false} iconType="nointernet-banking"/>
            );
        } else {
            content = (
                <div>
                    <h3>
                        <FormattedText value="investment-title" />
                    </h3>
                    <div className="row investment-section__body">
                        <div className="col-xs-7 first-column">
                            <h4 className="investment-section__body--subtitle">
                                <FormattedText value="investment-fund" />
                            </h4>
                            <b>
                                {immMorningStarInvestmentData.get('name')}
                            </b>
                        </div>
                        <div className="col-xs-1">
                            <h4 className="investment-section__body--subtitle">
                                <FormattedText value="investment-ytd" />
                            </h4>
                            <b>
                                {immMorningStarInvestmentData.get('returnM0')}
                            </b>
                        </div>
                        <div className="col-xs-1">
                            <h4 className="investment-section__body--subtitle">
                                <FormattedText value="investment-oneYear" />
                            </h4>
                            <b>
                                {immMorningStarInvestmentData.get('returnM12')}
                            </b>
                        </div>
                        <div className="col-xs-1">
                            <h4 className="investment-section__body--subtitle">
                                <FormattedText value="investment-threeYears" />
                            </h4>
                            <b>
                                {immMorningStarInvestmentData.get('returnM36')}
                            </b>
                        </div>
                        <div className="col-xs-1">
                            <h4 className="investment-section__body--subtitle">
                                <FormattedText value="investment-fiveYears" />
                            </h4>
                            <b>
                                {immMorningStarInvestmentData.get('returnM60')}
                            </b>
                        </div>
                    </div>

                    <div className="row investment-section__body second-row">
                        <div className="col-xs-7 first-column">
                            <h4 className="investment-section__body--subtitle">
                                <FormattedText value="investment-category" />
                            </h4>
                            <b>
                                {immMorningStarInvestmentData.get('categoryName')}
                            </b>
                        </div>
                        <div className="col-xs-4">
                            <h4 className="investment-section__body--subtitle bold">
                                <FormattedText value="investment-rating" />
                            </h4>
                            <StarsRating
                                total={5}
                                actual={immMorningStarInvestmentData.get('rating') || 0}
                            />
                        </div>
                    </div>

                    <div className="row investment-section__body">
                        <div className="col-xs-12 text-right text-uppercase">
                            <OKLink modifier="emphasize" to="/myprofile/broker">
                                <FormattedText value="investment-seeDetails" />
                            </OKLink>
                        </div>
                    </div>
                </div>
            );
        }

        return (
            <section className="investment-section">
                {content}
            </section>
        );
    }
}

Investment.propTypes = {
    fundId: PropTypes.string.isRequired,
    getMorningStarInvestmentData: PropTypes.func,
    immMorningStarInvestmentData: PropTypes.object.isRequired,
    immMovements: PropTypes.object.isRequired,
    immImposition: PropTypes.object.isRequired
};

module.exports = Investment;
